import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const faqs = [{
  q: 'Was genau bekomme ich beim Kauf?',
  a: 'Du erhältst sofortigen Zugriff auf 100+ Schritt-für-Schritt-Roboter-Projektanleitungen im PDF-Format, plus alle 3 Boni: das Cardboard Arcade Pack, den 5-Minuten-Papercraft-Guide und Kleine Kreative: Slime & Sensorik. Alles wird digital geliefert — kein Versand, kein Warten.'
}, {
  q: 'Welche Materialien muss ich kaufen?',
  a: 'Fast alles, was du brauchst, hast du bereits zu Hause — Kartons, Plastikflaschen, Klebeband, Gummibänder, Flaschendeckel, Stifte und Scheren. Jedes Projekt listet die benötigten Materialien vorab klar auf, damit es keine Überraschungen gibt.'
}, {
  q: 'Für welches Alter ist MakerLab gedacht?',
  a: 'MakerLab ist für Kinder von 4 bis 12 Jahren gedacht. Die Projekte sind nach Schwierigkeitsgrad geordnet — einfache eignen sich perfekt für jüngere Kinder mit etwas elterlicher Hilfe, während die anspruchsvolleren Projekte ideal für ältere Kinder sind, die ein echtes Technik-Erlebnis wollen.'
}, {
  q: 'Braucht mein Kind Vorkenntnisse?',
  a: 'Überhaupt nicht. Jedes Projekt beginnt bei null — vollständig bebildert, Schritt für Schritt, in einfacher Sprache, der jedes Kind folgen kann. Kein Robotik-Wissen, kein Programmieren, kein technischer Hintergrund nötig. Nur Neugier und zwei Hände.'
}, {
  q: 'Wie greife ich auf meinen Kauf zu?',
  a: 'Direkt nach dem Kauf erhältst du eine E-Mail mit einem Download-Link. Du kannst deine Dateien von jedem Gerät aus abrufen — Handy, Tablet oder Computer. Die PDFs lassen sich beliebig oft öffnen, speichern und drucken.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream py-16 sm:py-24" data-id="element-40">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-41">
        <SectionHeading eyebrow="Fragen?" title={<>Häufig gestellte Fragen</>} subtitle="Alles, was du vor dem Start wissen musst." data-id="element-42" />
        <div className="mt-12 space-y-3" data-id="element-43">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl border border-ink/10 bg-white" data-id="element-44">
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left" data-id="element-45">
                  <span className="font-display text-base font-bold text-ink sm:text-lg" data-id="element-46">
                    {f.q}
                  </span>
                  <PlusIcon className={`h-5 w-5 flex-none text-brand transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-47" />
                </button>
                <AnimatePresence initial={false} data-id="element-48">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-49">
                      <p className="px-6 pb-6 text-sm leading-relaxed text-ink/60" data-id="element-50">
                        {f.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}